// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship Column
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.RelationshipConstants';

function RelationshipColumn() {
  const {
    component: ChildComponent,
    store: relationshipVM,
    fieldCheck,
    classes,
    rowIndex,
    validationsRules,
    componentOptions,
    selectedFunction,
    setFunction
  } = this.props;

  const disabledWhenShowOnlyOneDataSource =
    !!relationshipVM.querySource &&
    (fieldCheck == constants.FIELDCHECK.DATABASE_FIELD || fieldCheck == constants.FIELDCHECK.JOIN_QUERYSOURCE_FIELD);
  const disabled = !this.props.relationshipItem.editable
    ? true
    : disabledWhenShowOnlyOneDataSource
    ? true
    : this.props.relationshipItem.isDisableField(fieldCheck);
  const disabledRelationship = this.props.relationshipItem.disabled;

  return (
    <ChildComponent
      disabled={disabled || disabledRelationship}
      className={'validation-border ' + classes}
      field={fieldCheck}
      group={constants.RELATIONSHIP_LABEL + rowIndex}
      value={selectedFunction}
      onChange={setFunction}
      validations={validationsRules}
      {...componentOptions}
    />
  );
}

RelationshipColumn.propTypes = {
  relationshipItem: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  fieldCheck: PropTypes.string.isRequired,
  selectedFunction: PropTypes.any,
  setFunction: PropTypes.func,
  component: PropTypes.func.isRequired,
  componentOptions: PropTypes.object
};

RelationshipColumn.defaultProps = {
  validationsRules: constants.REQUIRED_CONSTRAINT
};

export default observer(RelationshipColumn);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.RelationshipColumn.jsx